import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images } from "../../data/content";
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-162" data-mp="cuta3xqn1n4v">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-163" data-mp="huo1s3i8mgqz">
        <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-164" data-mp="hsl2stz3xda4">
          <div className="flex items-center gap-2" data-id="element-165" data-mp="mts90ollq4eo">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy font-serif text-lg font-bold text-gold-light" data-id="element-166" data-mp="qv40kzo1czpi">DR</span>
            <span className="font-serif text-lg font-bold text-navy" data-id="element-167" data-mp="vn48beackwwn">Decision Lab™</span>
          </div>
          <span className="rounded-full border border-gold/50 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-navy" data-id="element-168" data-mp="10knk87jkoxlf">
            Blepharoplasty Decision Lab™
          </span>
        </div>

        <h1 className="mt-7 font-serif text-[2.1rem] font-bold leading-[1.1] text-ink sm:text-5xl md:text-6xl" data-id="element-169" data-mp="1ahikovzep82c">
          Train your clinical reasoning through{" "}
          <em className="text-gold" data-id="element-170" data-mp="4ny9twntxxxd">30 educational</em> blepharoplasty cases
        </h1>

        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-171" data-mp="3vw2cuusicuqd">
          A structured case-based training system to analyze an educational case in about{" "}
          <strong className="text-ink" data-id="element-172" data-mp="setv0axs5uvn">15 minutes</strong>, identify what deserves attention, recognize information gaps and turn
          every case into a learning opportunity.
        </p>

        <p className="mt-5 rounded-xl bg-navy px-4 py-2.5 text-sm font-bold text-white sm:text-base" data-id="element-173" data-mp="io91v30vlik4">
          6 Premium Volumes + 5 Professional Bonuses + 30 Educational Cases
        </p>

        <img src={images.hero} alt="Blepharoplasty Decision Lab box set with six volumes, tablet case analysis and printable worksheets" className="mt-8 w-full max-w-3xl" data-id="element-174" data-mp="1b4s6l10se641" />

        <CtaButton id="hero-cta" label="I want the Decision Lab™" subtext="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" className="mt-6" data-id="element-175" data-mp="30ldw2uddboj7" />

        <div className="mt-10 flex w-full flex-col items-center gap-8" data-id="element-176" data-mp="2qvciwxmjzqj2">
          <Countdown data-id="element-177" data-mp="2vup31am1ijhy" />
          <ScarcityBar data-id="element-178" data-mp="2vu5om3vlmd8o" />
        </div>
      </div>
    </header>;
}